export default "__VITE_ASSET__6EGWbH_8__"